export const LOGIN = '/login';
export const SIGNUP = '/sign-up';
export const DASHBOARD = '/';
export const PROFILE = '/u/:username';
export const PROFILE_SAVED = '/u/:username/saved';
export const NOT_FOUND = '/not-found';
export const ACCOUNT = '/accounts';
export const EDIT_PROFILE = '/accounts/edit';
export const PASSWORD = '/accounts/password/';
export const RESET_PASSWORD = '/accounts/password/reset';
export const CHANGE_PASSWORD = '/accounts/password/change';
export const NOTIFICATIONS = '/accounts/notifications';
export const PRIVACY_AND_SECURITY = '/accounts/privacy-and-security';
export const POST = '/p/:postId';
export const INBOX = '/direct/inbox';
export const CHAT = '/direct/inbox/:chatId';
export const EXPLORE = '/explore';
export const SUGGESTIONS = '/explore/people/suggested';
